<template>
  <div class="document-style">
    <ul class="fs-16">
      <li>
        <div class="mt-32">
          <div class="title-list-style">People Impact & Risk Trends</div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Trends and topics from
              employees within the last 4 weeks
            </div>
          </div>
          <div class="note-box">
            <div class="fw-700">Risk levels</div>
            <div class="flex-center mt-4">
              <div
                class="px-8 mr-6"
                style="
                  color: #fff;
                  font-weight: 700;
                  box-shadow: 0px 2px 4px #0000002d;
                  background-color: #e21a1a;
                  border-radius: 4px;
                "
              >
                &nbsp;
              </div>
              <div>
                <span class="fw-700">Low: </span>
                <span>.....</span>
              </div>
            </div>
            <div class="flex-center mt-4">
              <div
                class="px-8 mr-8"
                style="
                  color: #fff;
                  font-weight: 700;
                  box-shadow: 0px 2px 4px #0000002d;
                  background-color: #c41919;
                  border-radius: 4px;
                "
              >
                &nbsp;
              </div>
              <div>
                <span class="fw-700">Medium: </span>
                <span>.....</span>
              </div>
            </div>
            <div class="flex-center mt-4">
              <div
                class="px-8 mr-10"
                style="
                  color: #fff;
                  font-weight: 700;
                  box-shadow: 0px 2px 4px #0000002d;
                  background-color: #900505;
                  border-radius: 4px;
                "
              >
                &nbsp;
              </div>
              <div>
                <span class="fw-700">Height: </span>
                <span>.....</span>
              </div>
            </div>
            <div class="fw-700 mt-4">AVG impact rating</div>
            <div class="flex-center">
              <div
                class="mr-10"
                style="
                  width: 18px;
                  height: 2px;
                  border-radius: 2px;
                  background-color: #35d077;
                "
              ></div>
              <div>AVG impact rating</div>
            </div>
          </div>
          <!-- <div class="tip-box">
            <span class="note-header">Note:</span>
            <span>
              You can see the record of employees talking points and interests
              in all dimensions from the past months by click on
              <span class="fw-700">"show timeline"</span> label.
            </span>
          </div> -->
          <div class="mt-12">
            <span class="fw-700">Power Skills:</span>
            <span>
              After employees answer daily open-ended questions, skills
              improvement will be collected and shown in the different colour
              bars.
            </span>
            <span>###Power Skills</span>
          </div>
          <div class="mt-12">
            <span class="fw-700">Network Type:</span>
            <span>
              Employees’ network, measured by the distance in a relationship
              according to an organizational chart and the interactions between
              colleagues by giving coins, peer feedback, or gifts.
            </span>
            <span class="link-ref" @click="channgeMenu('Keynote_Talent_Types')"
              >#Network Type</span
            >
          </div>
          <div class="mt-12">
            <span class="fw-700">Talent Type:</span>
            <span>
              Employees’ talent, measured from the frequency and the quality of
              recognitions received from colleagues (coins) or managers (gems).
              Coins will measure employees’ networks, and Gems will measure
              employees’ performance.
            </span>
            <span>###Talent Type</span>
          </div>
          <div class="mt-12">
            <span class="fw-700">Excels At:</span>
            <span>
              This comes from the question, “What did [employee] excel at?” in
              Peer Feedback.
            </span>
          </div>
        </div>
      </li>
      <li>
        <div class="mt-32">
          <div class="title-list-style">PEOPLE INTELLIGENCE</div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; In-depth data on the
              Happiness & Risk Rate of each employee from the past 7 days. A
              score that represents an inviduals impact on the organization and
              the people around them, determined by
            </div>
          </div>
          <div class="mt-12">
            <div class="fw-700">Talent Type</div>
            <span>
              Talent is classified by frequency and quality of recognition
              (coins and gems) received. Coins are a measure of Network
              Effectiveness. Gems are a measure of Individual Performance. Based
              on manager and peer recognition in the past 6-months.
            </span>
          </div>
          <div class="mt-12">
            <div class="fw-700">Network Type</div>
            <span>
              Talent is classified by the number of inner and outer connections
              (as determined by the org structure) from recognition and peer
              feedback data in the past 6-months.
            </span>
          </div>
          <div class="mt-12">
            <div class="fw-700">Achievements</div>
            <span>
              Highlighting key accomplishments in engagement and recognition
              from peers and managers.
            </span>
            <div class="ml-24">
              <div class="mt-6">
                <span class="fw-700">Engagement Group:</span>
                <span>
                  Employee engagement is measured by behavior on Happily App,
                  divided into these groups.
                </span>
                <div class="note-box">
                  <div class="fw-700">Engagement Icons</div>
                  <div class="achievements-contariner">
                    <div class="flex-center">
                      <img
                        class="mt-4"
                        :src="$utils('icons', 'Engagement_Highly_Engaged_32')"
                        alt="icons_Engagement_Highly_Engaged_32"
                        title="Highly Engaged"
                      />
                      <div class="ml-12">Highly Engaged</div>
                    </div>
                    <div class="flex-center">
                      <img
                        class="mt-4"
                        :src="
                          $utils('icons', 'Engagement_Moderately_Engaged_32')
                        "
                        alt="icons_Engagement_Moderately_Engaged_32"
                        title="Engaged"
                      />
                      <div class="ml-12">Engaged</div>
                    </div>
                    <div class="flex-center">
                      <img
                        class="mt-4"
                        :src="$utils('icons', 'Engagement_Somewhat_Engaged_32')"
                        alt="icons_Engagement_Somewhat_Engaged_32"
                        title="Somewhat Engaged"
                      />
                      <div class="ml-12">Somewhat Engaged</div>
                    </div>
                    <div class="flex-center">
                      <img
                        class="mt-4"
                        :src="$utils('icons', 'Engagement_Under_Engaged_32')"
                        alt="icons_Engagement_Under_Engaged_32"
                        title="Under Engaged"
                      />
                      <div class="ml-12">Under Engaged</div>
                    </div>
                    <div class="flex-center">
                      <img
                        class="mt-4"
                        :src="$utils('icons', 'Engagement_In-Active_32')"
                        alt="icons_Engagement_In-Active_32"
                        title="Inactive"
                      />
                      <div class="ml-12">In-active</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-6">
                <span class="fw-700">Medals:</span>
                <span>
                  Medals from leaders for employees who work exceeding
                  expectations or their work aligned with organizational core
                  values.
                </span>
                <div class="note-box">
                  <div class="fw-700">Medal Icons</div>
                  <div class="flex-center">
                    <img
                      class="mr-12 mt-4"
                      :src="$utils('icons', 'Medals_32')"
                      alt="icons_Medals_32"
                      title="Medals"
                    />
                    <div>###medal</div>
                  </div>
                </div>
              </div>
              <div class="mt-6">
                <span class="fw-700">Truly Outstanding:</span>
                <span>
                  Truly Outstanding ratings from Peer Feedback received in the
                  past 6 months.
                </span>
                <div class="note-box">
                  <div class="fw-700">Truly Outstanding</div>
                  <div class="flex-center">
                    <img
                      class="mr-12 mt-4"
                      :src="$utils('icons', 'Outstanding_32')"
                      alt="icons_Outstanding_32"
                      title="Truly Outstanding"
                    />
                    <div>###medal</div>
                  </div>
                </div>
              </div>
              <div class="mt-6">
                <span class="fw-700">Star Performer:</span>
                <span>
                  The top 15% of high performers in the organization last week,
                  measured by the amount of work-related recognitions they
                  received
                </span>
                <div class="note-box">
                  <div class="fw-700">Star Performer</div>
                  <div class="flex-center">
                    <img
                      class="mr-12 mt-4"
                      :src="$utils('icons', 'Super_Star_32')"
                      alt="icons_Super_Star_32"
                      title="Weekly Top Performer"
                    />
                    <div>
                      The number on the icon represents a number of weeks
                      qualified as a Star Performer and the number of medals
                      received in the past 6-months.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-12">
            <div class="fw-700">Impact Rating</div>
            <span>
              A score that represents an individual impact on the organization
              and the people around them, determined by various factors in the
              past 6 months; for example, engagement with colleagues on Happily
              App, recognitions, medals, or using other features on the App
            </span>
          </div>
          <div class="mt-12">
            <div class="fw-700">Risk Level</div>
            <span>
              Talent that are retention risks detected from the frequency of
              “Not Great” and “Unhappy” responses related to “How are you
              feeling today?”
            </span>
          </div>
          <!-- <div class="note-box">
            <div class="link-ref" @click="channgeMenu('Keynote_Dimension')">
              #Dimension
            </div>
            <div class="fw-700 mt-4">
              How to calculate Success Score (out of 100)
            </div>
            <div class="flex-center">
              <div
                style="
                  border: 1px solid #000;
                  padding: 4px 0 4px 4px;
                  border-right: 0;
                  height: 34px;
                "
              ></div>
              <div>
                <div class="center">
                  (
                  <span style="color: #66bb6a"
                    >(number of green teams x 1)</span
                  >
                  +
                  <span style="color: #fbc02d"
                    >(number of yellow teams x 0.5)</span
                  >
                  +
                  <span style="color: #f44336">(number of red teams x 0)</span>
                  )
                </div>
                <div class="center" style="border-top: 1px solid #000">
                  Number of all teams in the dimension
                </div>
              </div>
              <div
                style="
                  border: 1px solid #000;
                  padding: 4px 0 4px 4px;
                  border-left: 0;
                  height: 34px;
                "
              ></div>
              <div class="pr-4 pl-4">x 100</div>
              <div class="pr-4">=</div>
              <div class="fw-700">Success Score</div>
            </div>
          </div> -->
          <!-- <div class="tip-box">
            <span class="note-header">Note:</span>
            <span>
              Click on each dimension to see Success Score and Talking Points
              record from the past 30 days/ 1 years.
            </span>
          </div> -->
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    channgeMenu(menu) {
      this.$emit("changedMenu", menu);
    },
  },
};
</script>
    
  <style lang="scss" scoped></style>